export class IntroSection {
    public image: string;
    public Title: string;
    public Description: string;
}
